<template>
  <div class="register-page" :class="{dark:documentsAreSent}">
    <modal-wrapper v-if="isWaitingForDiiaDocuments">
      <modal-container class="doc-waiting" :show-close="false">
        <div class="doc-waiting__title">
          {{ $t('common.waiting-for-diia-documents') }}
        </div>
        <img
          class="doc-waiting__loader"
          width="110"
          height="110"
          src="@/assets/img/loader.svg"
        />
        <div>{{ $t('common.time-of-waiting-diia-documents-from-server') }}</div>
        <br />
        <div>{{ $t('common.if-you-have-problems') }}</div>
        <icu-contacts view-type="horizontal" :show-phone="false" email-to="support" />

      </modal-container>
    </modal-wrapper>

    <modal-wrapper v-if="isWaitingForDocuments">
      <modal-container class="doc-waiting" :show-close="false">
        <div class="doc-waiting__title">
          {{ $t('common.waiting-documents-from-server') }}
        </div>
        <img
          class="doc-waiting__loader"
          width="110"
          height="110"
          src="@/assets/img/loader.svg"
        />
        <div>{{ $t('common.time-of-waiting-documents-from-server') }}</div>
        <br />
        <div>{{ $t('common.if-you-have-problems') }}</div>
        <icu-contacts view-type="horizontal" :show-phone="false" email-to="support" />

      </modal-container>
    </modal-wrapper>
    <verification-modal
      v-if="isSmsModalDisplayed"
      type="phone"
      align="center"
      email-to="support"
      :is-doc-sign="true"
      :is-resident="false"
      :block-time="timeLeft"
      :tries-left="triesLeft"
      :error="$t(verificationErrorMessage)"
      @confirm="sendOtpCode"
      @resend="signDocuments"
    >
      <template #title>
        <span v-html="$t('verification-modal.code-was-sent-to-phone', {phone: hiddenPhone})" />
      </template>
    </verification-modal>

    <verification-modal
      v-if="isEmailModalDisplayed"
      key="email"
      type="email"
      :is-doc-sign="true"
      :is-resident="false"
      :block-time="timeLeft"
      :tries-left="triesLeft"
      :error="$t(verificationErrorMessage)"
      @resend="signDocuments"
      @confirm="sendOtpCode"
    >
      <template #title>
        <span v-html="$t('verification-modal.code-was-sent-to-email', {email: hiddenEmail})" />
      </template>
    </verification-modal>

    <status-bar :title="documentsAreSent ? '': $t('document-sign.title')" />
    <div v-if="!documentsAreSent" class="register-page-form">
      <icu-loader v-if="isLoading" />
      <template v-if="showDocumentList">
        <div class="register-page-form-text">
          {{ $t('document-sign.text') }}
        </div>
        <div class="document__list">
          <div v-for="document in documents" :key="document.name" class="document__item">
            <checkbox-input v-model="document.signed">
            </checkbox-input>
            <div class="document__name" :title="document.title[$i18n.locale]">
              {{ document.title[$i18n.locale] }}
            </div>
            <div
              class="document__download"
              @click="downloadDoc(document.uuid, document.title[$i18n.locale])"
            >
              <span>{{ $t('document-sign.download') }}</span>
              <img src="@/assets/img/download-pdf.svg" />
            </div>
          </div>
        </div>
        <pc-button
          v-if="userInfo.is_resident"
          variant="dark"
          :disabled="isDisabled"
          @click="signDiia"
          v-html="$t('document-sign.sign-by-diia')"
        />
        <pc-button
          v-else
          variant="dark"
          :disabled="isDisabled"
          @click="signDocuments"
        >
          {{ $t('document-sign.button-text') }}
        </pc-button>
        <div class="support-info">
          <p>{{ $t('document-sign.if-find-errors') }}</p>
          <icu-contacts :show-phone="false" email-to="onboarding" />
        </div>
      </template>
    </div>
    <div v-else class="register-page-form">
      <div class="register-success">
        <div class="register-success__title">
          {{ $t($options.statuses_data[signStatus].title) }}
        </div>
        <img
          v-if="signStatus === 'success'"
          src="@/assets/img/views/RegisterFinalPage/final-page.svg"
          alt="final-page"
          class="register-success__img"
        />
        <img
          v-else
          src="@/assets/img/invalid.png"
          alt="final-page"
          class="register-success__img"
        />
        <div class="register-success-text">
          <p v-html="$t($options.statuses_data[signStatus].text)"></p>
        </div>
      </div>
      <div class="register-page-form-actions">
        <pc-button variant="dark" @click="clickHandler">
          {{ $t($options.statuses_data[signStatus].button) }}
        </pc-button>
      </div>
      <template v-if="signStatus!=='success'">
        <div class="contacts-info">
          {{ $t('common.if-you-have-problems') }}
        </div>
        <icu-contacts
          v-if="status !=='success'"
          view-type="horizontal"
          email-to="support"
          :show-phone="false"
        />
      </template>
    </div>
    <icu-support v-if="!documentsAreSent">
      {{ $t('document-sign.contact-support') }}
      <a href="mailto:support@icu.ua" target="_blank">support@icu.ua</a>
    </icu-support>
  </div>
</template>

<script>
import StatusBar from '@/components/views/RegisterPage/StatusBar'
import CheckboxInput from '@/components/inputs/CheckboxInput'
import PcButton from '@/components/common/PcButton.vue'
import IcuIcon from '@/components/common/IcuIcon'
import IcuSupport from '@/components/common/IcuSupport'
import VerificationModal from '@/components/modals/VerificationModal'
import {api} from '@/api/api'
import {constants} from '@/constants'
import IcuLoader from '@/components/common/IcuLoader'
import ModalWrapper from '@/components/modals/ModalWrapper'
import ModalContainer from '@/components/modals/ModalContainer'
import IcuContacts from '@/components/common/IcuContacts'
import {mapActions, mapGetters} from 'vuex'


export default {
  name: 'DocumentSign',
  components: {
    IcuContacts,
    ModalContainer,
    ModalWrapper, IcuLoader, VerificationModal, IcuSupport, IcuIcon, PcButton, CheckboxInput, StatusBar},
  data(){
    return {
      isLoading: true,
      isWaitingForDocuments: false,
      isWaitingForDiiaDocuments: false,
      documentsAreSent: false,
      triesLeft: 3,
      timeLeft: null,
      otpId: null,
      isSmsModalDisplayed: false,
      isEmailModalDisplayed: false,
      status: '',
      signStatus: 'error',
      hiddenPhone: '',
      hiddenEmail: '',
      verificationErrorMessage: '',
      documents: [],
      signRequestTimeStart: null,
      signRequestTimeEnd: null,
      phoneIsVerified: null
    }
  },
  tries: 3,
  STATUS_TYPES: constants.CHECK_STATUSES,
  statuses_data:{
    success:{
      title: 'document-sign.success.title',
      text: 'document-sign.success.text',
      button: 'document-sign.success.button'
    },
    error:{
      title: 'document-sign.error.title',
      text: 'document-sign.error.text',
      button: 'document-sign.error.button'
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isDisabled() {
      return this.documents?.findIndex(doc => !doc.signed) > -1
    },
    showDocumentList() {
      return this.documents.length
    }
  },


   async mounted(){
    if(!Object.hasOwn(this.userInfo, 'is_resident')) {
      await this.$store.dispatch('setUserInfo')
    }
    if(this.userInfo.is_resident){
      if(['REVIEW', 'INITIAL'].includes(this.userInfo.check_status) || !this.userInfo.check_status ) {
        this.isWaitingForDiiaDocuments = true
        this.waitStatusUpdate()
      }
      if(this.userInfo.check_status === 'APPROVED') {
        await this.getDiiaDocuments()
      }

    }else {
      if(this.userInfo.check_status === 'REVIEW') {
        this.isWaitingForDocuments = true
        this.waitStatusUpdate()
      }

      if(this.userInfo.check_status === 'APPROVED') {

        try {
          const res = await api.profile.nonresident.signOtp.get()
          this.documents = res.data
          this.documents.map(doc => doc.signed = true)
        } catch (err) {
          this.$toast.error(this.$t('notifications.something-went-wrong'))
          console.log(err)
        }
      }
      this.status = this.$route.params.status

      if (!this.status || this.status === this.$options.STATUS_TYPES.SIGNING) {
        await this.checkStatusUpdate()
      }


    }
     this.isLoading = false
  },
  methods: {
    ...mapActions(['setUserInfo']),
    waitStatusUpdate() {
      const checkStatus = setInterval(async() => {
        await this.setUserInfo()
        if(['REJECTED', 'ERRORS', 'APPROVED'].includes(this.userInfo.check_status)){
          clearInterval(checkStatus)
          await this.$router.push({name: 'form-status', params: {status: this.userInfo.check_status}})
        }
      },10000)
    },

    async getDiiaDocuments() {
      try {
        const {data} = await api.profile.resident.diiaSign.get()
        this.isWaitingForDiiaDocuments = false
        this.documents = data
      } catch (err) {
        console.log(err)
      }
    },
    async signDocuments(){
     this.verificationErrorMessage = ''
     this.isLoading = true
    const docsData = {}
    docsData.docs = this.documents.map(doc => {
      return {uuid: doc.uuid}
    })
    docsData.sign = true
     try {
       this.signRequestTimeStart = Date.now()
       const { data } = await api.profile.nonresident.signOtp.post(docsData)
       if( data.success) {
         this.hiddenEmail = data.email
         this.otpId = data.otp_id
         if(data.sms_otp_is_available) {
           this.isSmsModalDisplayed = true
         } else {
           this.isEmailModalDisplayed = true
         }
         await this.setOtpParams(data)
       }
     }catch(err) {
       const error = err.response.data
       if(error._error_code === 'SendSmsForbidden'){
         this.isSmsModalDisplayed = true
         await this.setOtpParams(error)

       } else {
         this.$toast.error(this.$t('notifications.something-went-wrong'))
         console.log(err)
       }
     }

   },
  async checkStatusUpdate(){
    const currentStatus = this.status
    try {
      const res = await api.auth.userInfo()
      this.status = res.data.check_status
    } catch (err) {
      this.$toast.error(this.$t('notifications.something-went-wrong'))
      console.log(err)
    }

    if (this.status === this.$options.STATUS_TYPES.SIGNING) {
      this.isWaitingForDocuments = true
      setTimeout(this.checkStatusUpdate, 30000)
    } else if (this.status === this.$options.STATUS_TYPES.SIGNED) {
      this.isWaitingForDocuments = false
      this.documentsAreSent = true
      this.signStatus = 'success'
    } else if (currentStatus === this.$options.STATUS_TYPES.SIGNING
        && this.status === this.$options.STATUS_TYPES.APPROVED) {
      this.isWaitingForDocuments = false
      this.documentsAreSent = true
      this.signStatus = 'error'
    }
  },
    async setOtpParams(data){
      this.signRequestTimeEnd = Date.now()
      this.hiddenPhone = data.phone
      this.triesLeft = this.$options.tries - data.tries
      this.timeLeft = null
      const requestTimeShift = this.signRequestTimeEnd - this.signRequestTimeStart
      setTimeout(()=> {
        this.timeLeft =  Math.round(data.seconds_left - requestTimeShift/1000)
      },0)
    },
    async downloadDoc(id, name){
     try{
      const res = await api.profile.downloadSignDoc(id)
       const blob = new Blob([res.data], { type: 'application/pdf' })
       const url = window.URL || window.webkitURL
       const link = url.createObjectURL(blob)
       const a = document.createElement('a')
       a.setAttribute('download', `${name}.pdf`)
       a.setAttribute('href', link)
       document.body.appendChild(a)
       a.click()
       document.body.removeChild(a)

     }catch(err){
       console.log(err)
       this.$toast.error(this.$t('notifications.something-went-wrong'))
     }
    },
    async sendOtpCode(code){
      try {
        const res = await api.profile.nonresident.confirmSignOtp.post({code, otp_id: this.otpId})
        if(res.data.success){
          this.isWaitingForDocuments = true
          this.isSmsModalDisplayed = false
          this.isEmailModalDisplayed = false
          await this.checkStatusUpdate()
        }
      } catch(err) {
        if(err.response.data.code?.includes('Sign Documents Error')){
          this.isSmsModalDisplayed = false
          this.isEmailModalDisplayed = false
          this.documentsAreSent = true
          this.signStatus = 'error'
        } else if(err.response.data.message){
          this.triesLeft --
          this.verificationErrorMessage = err.response.data.message
        } else {
          this.$toast.error(this.$t('notifications.something-went-wrong'))
        }
        console.log(err.response)
      }
    },
    async clickHandler(){
     if(this.signStatus === 'error'){
       this.documentsAreSent = false
       this.isLoading = false
     } else {
       await this.$router.push({name: 'private-cabinet'})
     }
    },

    async signDiia() {
      const docs = []
      this.documents.forEach(doc => {
        docs.push({uuid: doc.uuid})
      })
      try {
        const {data} = await api.profile.resident.diiaSign.post({docs})
        await this.$router.push({name: 'diya-qr-code-sign', params:{skipCheck: true, qr_data: data}})

      }catch(err) {
        console.log(err)
      }
    }
   }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/views/register-common.scss";
@import "~@/assets/scss/views/document-list.scss";

.register-page.dark {
  background: rgba(0, 78, 96, 0.2);

  .register-page-form {
    padding-bottom: 60px;
    margin: 60px auto 60px;
    @media (max-width: 900px) {
      margin: 0 auto;
    }
  }
}
.doc-waiting {
  text-align: center;

  &__title{
    font-weight: 600;
    font-size: 20px;
  }


  &__loader {
    animation:spin 2s linear infinite;
    transform-origin: 53% 50%;
    margin: 70px auto 50px;
  }
}

.support {
  width: 57px;
  height: 57px;
  background: #FFFFFF;
  border-radius: 100%;
  position: fixed;
  right: 52px;
  bottom: 21px;
}

.contacts-info {
  max-width: 460px;
  text-align: center;
  margin: 30px auto 0;
}

.support-info {
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    display: block;
    max-width: 440px;
    padding: 10px 0;
    text-align: center;
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform:rotate(360deg);
  }
}
</style>
